import React from 'react';
import './Video.css';

const Video = () => {
  return (
    <div className="navbar-container">
      <video
        autoPlay
        loop
        muted
        playsInline
        className="video-background"
        poster="/video-placeholder.jpg"
      >
        <source src="/full-video.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
};

export default Video;
